<template>
  <v-container class="management-page" fluid>
    <div class="management-header">
      <h1 class="management-header__title">{{ $route.meta.title }}</h1>
      <div class="management-header__actions">
        <v-btn
          v-if="$checkPermission('create_management_company')"
          color="primary"
          class="management-header__btn text-none"
          dark
          rounded
          to="/management/new"
        >
          <v-icon left>mdi-plus</v-icon>
          Новая управляющая компания
        </v-btn>
      </div>
    </div>

    <v-card class="management-block mt-3" flat outlined>
      <div class="management-filters">
        <div class="management-filters__title">
          <v-icon left small>mdi-filter-variant</v-icon>
          Фильтры
        </div>
        <div class="management-filters__row">
          <v-text-field
            v-model="filterName"
            @keyup.enter="filterCompanies"
            placeholder="Название"
            prepend-inner-icon="mdi-rename-box-outline"
            outlined
            dense
            hide-details
            class="management-filters__field"
          />
          <v-btn color="primary" class="text-none" dark rounded @click.prevent="filterCompanies">
            <v-icon left>mdi-magnify</v-icon>
            Поиск
          </v-btn>
        </div>
      </div>
      <v-divider class="my-0" />
      <v-data-table
        class="table"
        :headers="headersCompany"
        :items="managementCompanies"
        :options.sync="options"
        :server-items-length="totalCompanies"
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100, 500],
          showFirstLastPage: true,
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-row justify="center" class="flex-nowrap">
            <v-tooltip v-if="$checkPermission('update_management_company')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0 mr-1"
                  width="18"
                  height="18"
                  :to="`/management/${item.id}/edit`"
                >
                  <v-icon size="large">mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Редактировать</span>
            </v-tooltip>
            <v-tooltip v-if="$checkPermission('destroy_management_company')" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  small
                  v-bind="attrs"
                  v-on="on"
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  @click.stop="$set(dialog, item.id, true)"
                >
                  <v-icon size="large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
            <v-dialog v-model="dialog[item.id]" persistent :retain-focus="false" max-width="320" content-class="dialog-border-radius" :key="item.id">
              <v-card>
                <v-card-title class="management-dialog__title">Удалить управляющую компанию?</v-card-title>
                <v-card-text>Подтверждая, вы удалите компанию.</v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn text color="grey" @click="$set(dialog, item.id, false)">Отменить</v-btn>
                  <v-btn color="primary" text @click.prevent="removeManagementCompany(item.id)">Удалить</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Management',
  data () {
    return {
      isCreated: false,
      dialog: {},
      options: {
        itemsPerPage: 20,
      },
      filters: {},
      filterName: '',
      sort: '',
      totalCompanies: 0,
      headersCompany: [
        {
          text: 'id',
          value: 'id',
        },
        {
          text: 'Название',
          value: 'name',
        },
        {
          text: 'Адрес',
          value: 'address',
          sortable: false,
        },
        {
          text: 'Контакты',
          value: 'contacts',
          sortable: false,
        },
        {
          text: 'Группа',
          value: 'management_group.name',
          sortable: false,
        },
        {
          text: 'Кол-во домофонов',
          value: 'doorphones_count',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      managementCompanies: 'ManagementCompany/managementCompanies',
    }),
  },
  methods: {
    ...mapActions({
      getManagementCompanies: 'ManagementCompany/getManagementCompanies',
      deleteManagementCompany: 'ManagementCompany/deleteManagementCompany',
    }),
    removeManagementCompany (id) {
      this.deleteManagementCompany(id)
        .then(() => {
          this.$flash_success('Компания успешно удалена');
          this.getManagementCompanies();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при удалении управляющей компании');
        });
      this.dialog[id] = false;
    },
    loadManagementCompanies () {
      this.getManagementCompanies({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        filters: this.filters,
        sort: this.sort,
      })
        .then((response) => {
          this.totalCompanies = response.meta.total;
        })
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке управляющих компаний');
        });
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterCompanies();
      }
    },
    filterCompanies () {
      this.options.page = 1;
      this.filters = {};

      if (this.filterName) {
        this.filters.name = this.filterName;
      }

      this.loadManagementCompanies();
    },
  },
  created () {
    this.isCreated = true;
    this.loadManagementCompanies();
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadManagementCompanies();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.management-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 8px 0;
}

.management-header__title {
  font-size: 1.5rem;
  font-weight: 400;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.02em;
}

.management-header__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.management-header__btn {
  text-transform: none;
  font-weight: 500;
}

.management-block {
  border-radius: 12px;
  overflow: hidden;
}

.management-filters {
  padding: 10px 16px 8px;
}

.management-filters__title {
  font-size: 0.875rem;
  font-weight: 600;
  color: #546e7a;
  padding: 0 0 6px 0;
  margin: 0;
  display: flex;
  align-items: center;
}

.management-filters__row {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.management-filters__field {
  max-width: 320px;
  width: 100%;
  min-width: 180px;
}

.management-dialog__title {
  font-size: 1.1rem;
  font-weight: 600;
}

@media screen and (max-width: 600px) {
  .management-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .management-header__title {
    font-size: 1.4rem;
  }

  .management-filters__field {
    max-width: none;
  }
}
</style>
